import { Figure, Corner, SectionHead } from "./Primitives";
import { Illu } from "./Illustrations";
import { ArrowRight } from "lucide-react";

export const CustomWork = ({ texts, works, onRequestCustom }) => (
  <section id="custom" data-testid="custom-section" className="relative overflow-hidden border-b border-paper-line ap-section">
    {/* anatomical study reaching into the free background, behind the content */}
    <div
      className="ap-illu pointer-events-none absolute -right-10 top-6 hidden w-[380px] opacity-[0.14] lg:block xl:w-[440px]"
      aria-hidden="true"
    >
      <Illu name={texts.illu_custom} fallback="head" className="h-full w-full" />
    </div>

    <div className="ap-container relative">
      <div className="grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
        <SectionHead stamp="AP · CUSTOM" title={texts.custom_h2} intro={texts.custom_body} />
        <div className="flex flex-col justify-end gap-4 lg:items-start">
          <ul className="space-y-3">
            {[
              "Ornamente, Lettering, Porträts und kleine Motive sind willkommen.",
              "Referenzbilder helfen, sind aber kein Muss.",
              "Auch Cover-ups und Ergänzungen bestehender Arbeiten.",
            ].map((t) => (
              <li key={t} className="flex gap-3 ap-body text-charcoal">
                <span className="mt-2 h-px w-5 shrink-0 bg-signal" aria-hidden="true" />
                {t}
              </li>
            ))}
          </ul>
          <button type="button" onClick={onRequestCustom} data-testid="custom-cta" className="ap-btn-solid mt-2">
            Eigene Idee anfragen <ArrowRight size={16} />
          </button>
        </div>
      </div>

      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {works.map((w, i) => (
          <article
            key={w.id}
            data-testid={`custom-work-${i}`}
            className={`ap-card group ${i === 1 ? "lg:mt-8" : ""} ${i === 3 ? "lg:mt-4" : ""}`}
          >
            <Corner />
            <Figure
              src={w.image}
              mediaId={w.image_media_id}
              alt={`${w.title} – individuelle Tattooarbeit`}
              code={w.code}
              ratio="aspect-square"
            />
            <div className="p-4">
              <h3 className="font-display text-base font-bold uppercase tracking-wide text-ink">{w.title}</h3>
              <p className="ap-stamp mt-1">{w.placement}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
